export enum SalesforceLimitType {
  DAILY_API_REQUESTS = 'DailyApiRequests',
  DAILY_BULK_API_BATCHES = 'DailyBulkApiBatches',
  DAILY_STREAMING_API_EVENTS = 'DailyStreamingApiEvents',
  DAILY_FUNCTIONS_API_CALL_LIMIT = 'DailyFunctionsApiCallLimit',
  FILE_STORAGE_MB = 'FileStorageMB',
  SINGLE_EMAIL = 'SingleEmail'
}
